import { Button, Tooltip, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { useMemo } from "react";

// Styled button component

// CountButton Component
const CountButton = ({
  icon,
  count,
  tooltip,
  onClick,
  color = "default",
  active = false,
  sx,
}) => {
  const styles = useMemo(() => {
    return {
      textTransform: "none",
      //   color: theme.palette.text.secondary,
      //   padding: "6px 12px",
      p: 0,
      minWidth: "auto",
      //   gap: "6px",
      gap: "2px",
      fontSize: "10px !important",
      fontWeight: 400,
      "&:hover": {
        boxShadow: "none",
        color: (theme) => theme.palette.primary.main,
      },
      ".MuiButton-icon": {
        m: 0,
      },
      //   "&:hover": {
      //     backgroundColor: theme.palette.action.hover,
      //     color: theme.palette.primary.main,
      //   },
      "& .MuiSvgIcon-root": {
        fontSize: "12px",
      },
      ...sx,
    };
  }, [sx]);
  // Format count to show abbreviated numbers (1.2k, 3.5M, etc.)
  const formatCount = (num) => {
    if (num >= 1000000) {
      return (num / 1000000).toFixed(1) + "M";
    }
    if (num >= 1000) {
      return (num / 1000).toFixed(1) + "k";
    }
    return num.toString();
  };

  return (
    <Tooltip title={tooltip} arrow placement="top">
      <Button onClick={onClick} startIcon={icon} color={color} sx={styles}>
        {/* <Typography variant="body2" component="span">
          {formatCount(count)}
        </Typography> */}
        {formatCount(count)}
      </Button>
    </Tooltip>
  );
};

export default CountButton;
